import React from 'react';
import classes from "./droppable-area.module.sass";
import PreviewImage from "../PreviewImage";
import cn from 'classnames'

const Sheets = ({ imageType, checkForeground, foreground, placeholder, background, ref, className,
                  studentImageUrl = null, displayImageTypeName = false, backgroundUrl }) => {
  const getLength = (classname) => {
    switch (classname) {
      case 'fivebyseven':
        return 2
      case 'threebyfive':
        return 4
      case 'wallets':
        return 8
      default:
        return 1
    }
  }

  return (
    <div className={cn(classes.container, displayImageTypeName && classes.withName)}>
      <div ref={ref} className={cn(className, displayImageTypeName && classes.withOptionName)}>
        {new Array(getLength(imageType.classname)).fill(0).map((_, i) => i).map((key) => (
          <PreviewImage
            key={key}
            foregroundUrl={checkForeground ? ((foreground && foreground.watermarkUrl) || studentImageUrl) : placeholder}
            backgroundUrl={backgroundUrl || (background && background.imageUrl)}
          />
        ))}
      </div>

      {displayImageTypeName && (
        <div className={classes.imageTypeName}>
          <p>
            {imageType.name}
          </p>
        </div>
      )}
    </div>
  )
}

export default Sheets;
